export default "__VITE_ASSET__3eeb0a1c__"